import React from 'react';
import { CheckCircle2, Sparkles } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useFadeIn } from '../hooks/useFadeIn';
export function Hero() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  const trustBadges = ['Cuenta Verificada', '+1.000 Sonrisas', 'Valoración Gratis', 'Tecnología Digital'];
  return <section id="inicio" className="relative min-h-screen flex items-center pt-24 overflow-hidden bg-primary" data-id="element-230">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-231">
        <img src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=2000&q=80" alt="Consultorio moderno de Odontología Estética en Pereira" className="absolute inset-0 w-full h-full object-cover" data-id="element-232" />
        {/* Heavy dark overlay — premium dark gradient */}
        <div className="absolute inset-0 z-10" style={{
        background: 'linear-gradient(to right, rgba(10,10,10,0.96) 0%, rgba(10,10,10,0.90) 55%, rgba(10,10,10,0.72) 100%)'
      }} data-id="element-233"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-20 w-full py-12 lg:py-20" data-id="element-234">
        <div ref={ref} className={`max-w-3xl transition-all duration-1000 transform ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-235">
          {/* Eyebrow tag */}
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/40 text-gold rounded-full px-4 py-2 mb-6" data-id="element-236">
            <Sparkles size={16} className="text-gold" data-id="element-237" />
            <span className="text-sm font-medium tracking-wide" data-id="element-238">
              Clínica de Alta Estética en Pereira
            </span>
          </div>

          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl text-white leading-tight mb-6" data-id="element-239">
            Recupera la Confianza <br className="hidden sm:block" data-id="element-240" />
            en Tu Sonrisa
          </h1>

          <h2 className="text-gold text-xl sm:text-2xl font-medium mb-6 leading-snug" data-id="element-241">
            Expertos en Diseño de Sonrisa y Odontología de Alta Estética en
            Pereira
          </h2>

          <p className="text-white/85 text-base sm:text-lg mb-6 max-w-2xl leading-relaxed" data-id="element-242">
            Transformamos tu sonrisa con tecnología de última generación y los
            mejores materiales del mercado. Cada tratamiento se diseña a la
            medida de tu rostro para lograr un resultado natural, armónico y
            duradero.
          </p>

          <p className="text-white/70 text-base sm:text-lg mb-10 max-w-2xl leading-relaxed" data-id="element-243">
            Más de 5 años transformando sonrisas en el Eje Cafetero, con la
            confianza del Dr. Nicolás y su equipo de especialistas. Tu
            valoración inicial es completamente gratis.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-12" data-id="element-244">
            <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-gold hover:bg-gold-hover text-primary font-bold px-8 py-4 rounded-lg text-center transition-colors flex items-center justify-center gap-2" data-id="element-245">
              <span data-id="element-246">💬</span> Agenda tu Valoración GRATIS
            </a>
            <Link to="/antes-y-despues" className="bg-transparent border-2 border-gold text-gold hover:bg-gold/10 font-bold px-8 py-4 rounded-lg text-center transition-colors" data-id="element-247">
              Ver Nuestros Resultados ↓
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-x-6 gap-y-3 pt-8 border-t border-gold/15" data-id="element-248">
            {trustBadges.map((badge, index) => <div key={index} className="flex items-center gap-2 text-sm text-gray" data-id="element-249">
                <CheckCircle2 size={16} className="text-gold" data-id="element-250" />
                <span data-id="element-251">{badge}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}